// @flow

import React from 'react';
import glamorous from 'glamorous';
import Avatar from 'app/components/commons/Avatar';
import ucAvatarHolder from 'app/images/globalLeaderboard/hof-uc-avatar.png';

type Props = {
  avatar: ?Object,
  className?: string,
};

const defaultProps = {
  className: undefined,
};

const ChampionContainer = glamorous.div({
  position: 'relative',
  overflow: 'hidden',
  maxWidth: '100%',
});

const AvatarContainer = glamorous.div({
  position: 'absolute',
  top: 94,
  left: 101,
});

const StyledAvatar = glamorous(Avatar)({
  backgroundColor: 'grey',
});

const ChampionImage = glamorous.div({
  width: 353,
  height: 335,
  backgroundSize: 'contain',
  backgroundImage: `url(${ucAvatarHolder})`,
});

function UCAvatar({ avatar, className }: Props) {
  return (
    <ChampionContainer className={className}>
      <ChampionImage />
      <AvatarContainer>
        <StyledAvatar avatar={avatar} size="xlarge" square />
      </AvatarContainer>
    </ChampionContainer>
  );
}

UCAvatar.defaultProps = defaultProps;

export default UCAvatar;
